import React, { useContext, useEffect, useRef, useState } from "react";
import { ContactTeaserBar } from "./ContactTeaser.style";
import Button from "../Button/Button";
import { StateContext } from "../../context/stateContext";
import { InfiosContainer } from "../../utils/styled/_grid.style";
import { useIsMobile } from "../../utils/styled/_mixins.style";
import { sizes } from "../../utils/styled/_variables.styled";
import { ErrorBoundary } from "react-error-boundary";
import { urlHasParam } from "../../utils/js/params";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getWidthAndHeightProps } from "../../utils/js/widthAndHeight";

function ContactTeaser(props) {
  const {
    contactTitle,
    contactUserPhoto,
    contactUserPhotoCrops,
    contactAltUserPhoto,
    contactUserName,
    contactUserRole,
    contactTextButton,
    contactBackgroundImageCrops,
    contactHtmlId,
		contactUrl,
		contactUrlTarget,
    category,
  } = props;

  const { setIsOverlayFormOpen } = useContext(StateContext);

  useEffect(() => {
    if(sessionStorage.getItem('openCFO')) {
      handleOpenForms(true);
    }
  }, []);

  const handleOpenForms = (open) => {
		if (!contactUrl) {
			setIsOverlayFormOpen(open);
		}
  }

  const { isMobile } = useIsMobile(sizes.tabletLarge);

  const unsetGrid = useRef(null)

  useEffect(() => {
    unsetGrid.current?.parentElement.classList.add(`unset__grid`);
    },[]);


  const content = () => {
    return <>
      {contactTitle && <div className="contact__content">
        <div className={`contact__banner`} onClick={() => {
					if (contactUrl) {
						window.open(contactUrl, contactUrlTarget);
						return;
					}
          setIsOverlayFormOpen(true);
          window.location.href = "#contact-form";
        }}>
          <h4>{contactTitle}</h4>
          {contactUserPhoto && (
            <div className="contact__user">
              <LazyLoadImage src={contactUserPhotoCrops.leaderCard} alt={contactAltUserPhoto} />
              <div className="contact__info">
                <h6>{contactUserName}</h6>
                <p>{contactUserRole}</p>
              </div>
            </div>
          )}
          <div className="contact__button">
            {contactTextButton && (
              <Button tertiary inverted animated icon="play" text={contactTextButton}
                className={`contact-teaser-button`} />
            )}
          </div>
        </div>
      </div>}
    </>
  }

  return (
    <ContactTeaserBar ref={unsetGrid} id={contactHtmlId}>
      <div className="background-image">
        <img {...getWidthAndHeightProps(unsetGrid)} src={contactBackgroundImageCrops.contactTeaser} alt="background" />
      </div>
      {!isMobile && <InfiosContainer>
        {content()}
      </InfiosContainer>}
      {isMobile && content()}
    </ContactTeaserBar>
  );
}

const ContactTeaserHandleErrors = props => {
  return (
      <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ? <div style={{minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'}}><p>The contact teaser component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
          <ContactTeaser {...props}/>
      </ErrorBoundary>
  )
}

export default ContactTeaserHandleErrors;
